import React, { useState, useEffect } from "react";
import List from "../../newComponents/styledComponents/Table/List";
import * as Style from "../../newComponents/styledComponents/PersonalInstruction";
import menuIcon from "../../assets/images/DeathModuleNew/Menu.png";
import DEATH_API from "../../apis/death.api";
import Loader from "../../components/styled-components/loader/loader";
import Timer from "./Timer";
import swal from "sweetalert";
import moment from "moment";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import ModalVideo from "../../newComponents/ModuleVideos/ModalVideo";
export const SecureLinks = () => {
  const secureCols = [
    {
      title: "File Name",
      dataIndex: "fileName",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Expiration",
      dataIndex: ["expiration"],
      render: (fileName, record) => {
        return record.expiration ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {console.log("record", record)}{" "}
            <Timer endTime={record.expiration} startTime={record.createdAt} />
          </div>
        ) : (
          "N/A"
        );
      },
    },

    {
      title: "Secure Link URL",
      dataIndex: "url",
      render: (record) => (record ? record.substring(0, 20) + "..." : "N/A"),
    },

    {
      title: "Action",
      render: (record, index) => {
        // console.log("index...>>>",record.idx);
        return (
          <div>
            <div
              onClick={() => {
                setDropdown(!dropdown);
                getSelectedRow(record.id);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}>
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}></div>
                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        CopyUrl(record.url);
                        setDropdown(false);
                      }}>
                      Copy
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        deleteSelectedRow(record.id);
                        setDropdown(false);
                      }}>
                      Delete
                    </li>
                  </ul>
                </div>
              </>
            )}
          </div>
        );
      },
    },
  ];
  const [dropdown, setDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [secureLinks, setSecureLinks] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const CopyUrl = (URl) => {
    navigator.clipboard.writeText(URl);
    console.log("cooppues");
    swal("Success", "Copied", "success");
  };

  const timer = (seconds) => {
    var x = setInterval(function () {
      var now = new Date().getTime();
      console.log("now>>", now);
      var distance = seconds - now * 3600;

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        return 0;
      }
      return days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
    }, 1000);
  };

  const convertSeconds = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const hourString = hours > 0 ? `${hours} hour${hours > 1 ? "s" : ""}` : "";
    const minuteString =
      minutes > 0 ? `${minutes} minute${minutes > 1 ? "s" : ""}` : "";
    const secondString =
      remainingSeconds > 0
        ? `${remainingSeconds} second${remainingSeconds > 1 ? "s" : ""}`
        : "";

    if (hours > 0) {
      return `${hourString} : ${minuteString || "0 minute"} ${
        secondString && `: ${secondString}`
      }`;
    } else if (!hours && minutes > 0) {
      return `${minuteString} ${secondString && `: ${secondString}`}`;
    }

    return secondString;
  };
  function secondsToDhms(seconds) {
    var seconds = parseInt(seconds, 10);

    var days = Math.floor(seconds / (3600 * 24));
    seconds -= days * 3600 * 24;
    var hrs = Math.floor(seconds / 3600);
    seconds -= hrs * 3600;
    var mnts = Math.floor(seconds / 60);
    seconds -= mnts * 60;
    console.log(
      days +
        " days, " +
        hrs +
        " Hrs, " +
        mnts +
        " Minutes, " +
        seconds +
        " Seconds"
    );
    return days + " days, " + hrs + " Hrs, " + mnts + " Minutes";
  }

  const getSecureLinks = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let data = await DEATH_API.getSecureLink(ID);
      if (data && data.data) {
        setSecureLinks(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      throw new Error(error);
    }
  };

  const deleteSelectedRow = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          await DEATH_API.deleteSecureLink(id);
          setLoading(false);
          getSecureLinks();
        } catch (error) {
          console.log("error deleting Secure Link");
          console.log(error);
        }
        setTimeout(async () => {
          setLoading(true);
          swal("Deleted!", "Your file has been deleted.", "success");
          setLoading(false);
        }, 0);
      } else {
        swal("Cancelled", "Your file is safe :)", "error");
      }
    });
  };

  const getSelectedRow = (idx) => {
    console.log("idx", idx);
    setSelectedIndex(idx);
    // get selected row (this will return array of object)
    let selectedRow = secureLinks.filter((row, index) => {
      return row.id == idx;
    });

    // get first and only element from list and store it in update object
    console.log("selectedRow", selectedRow[0]);
    // setUpdateObject(selectedRow[0]);
  };
  useEffect(() => {
    getSecureLinks();
  }, []);

  return (
    <div style={{ padding: "2rem",position:"relative" }}>
      {" "}
      <ModalVideo module="Manage Secure Links" autoOpen={true} />
      <Style.MainHeading>Manage Secure Links </Style.MainHeading>
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>Manage Secure Links</Style.Title>
        </Style.HealthCardHeader>
        <List cols={secureCols} rows={secureLinks}></List>
      </Style.HealthCard>
      <NewLoader isLoading={loading} />
    </div>
  );
};
